module.exports = __webpack_public_path__ + "img/27.3ed696e3.jpg";